export var PrimitiveTypeEnum;
(function (PrimitiveTypeEnum) {
    PrimitiveTypeEnum["null"] = "Null";
    PrimitiveTypeEnum["undefined"] = "Undefined";
    PrimitiveTypeEnum["boolean"] = "Boolean";
    PrimitiveTypeEnum["number"] = "Number";
    PrimitiveTypeEnum["string"] = "String";
})(PrimitiveTypeEnum = PrimitiveTypeEnum || (PrimitiveTypeEnum = {}));
//# sourceMappingURL=primitive-type-enum.js.map